import { proxy } from 'valtio';
import {
	ApplicationsFilter,
	ApplicationSummaryList,
	PagingConfig,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { DEFAULT_PAGE_SIZE } from '../../../shared/Constants';

export const ApplicationsListState = proxy<{
	filterBy: ApplicationsFilter | undefined;
	paging: PagingConfig;
	applicationsList: ApplicationSummaryList;
}>({
	filterBy: undefined,
	paging: {
		pageNo: 1,
		pageSize: DEFAULT_PAGE_SIZE,
	},
	applicationsList: {
		applicationSummary: [],
		pagination: { totalNoOfRecords: 0 },
	},
});
